import { message } from 'antd'
import { RequisitionsApi } from '../../../../api/Corporates/Requisitions'
import RequisitionsLines from '../../../../components/Corporate/Requisitions/Lines/RequisitionsLines'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import React from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'
import { pick, get, isEmpty, upperCase } from 'lodash'
import * as stringSimilarity from 'string-similarity'
import OrdersApi from '../../../../api/Sales/Orders'

function RequisitionsLinesCont(props) {
  const { requisition, fetchRequisition = () => {} } = props

  let { list, fetching, fetch: fetchLine } = useFetchList(() =>
    RequisitionsApi.lines.list(requisition._key)
  )

  function fetch() {
    fetchLine()
    fetchRequisition()
  }

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, RequisitionsApi.lines.update, RequisitionsApi.lines.remove, fetch)

  const salesApi = new OrdersApi()
  const salesID = get(requisition, 'sales._id', '')
  let { list: sales, fetching: fetchingSales } = useFetchList(
    () => salesApi.read(salesID.replace('sales/', '')),
    [salesID],
    isEmpty(salesID)
  )

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await RequisitionsApi.lines.create({
        ...newObject,
        requisition: pick(requisition, ['_key', '_id', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()
  //

  const compareString = (a, b, threshold = 0.65) =>
    stringSimilarity.compareTwoStrings(upperCase(a), upperCase(b)) > threshold

  const selectionData = selection.map((s) => list.find((p) => get(p, '_id') === s))
  // console.log({ selection, selectionData})
  const filteredData = selectionData.filter((v) => {
    const sameVendor = get(v, 'vendor._id') === get(selectionData, '[0]vendor._id')
    const sameDAddress = compareString(
      get(v, 'delivery.address.label'),
      get(selectionData, '[0]delivery.address.label')
    )
    const sameDCountry = compareString(
      get(v, 'delivery.country'),
      get(selectionData, '[0]delivery.country')
    )
    const sameDLocation = compareString(
      get(v, 'delivery.location'),
      get(selectionData, '[0]delivery.location')
    )
    const sameDMethod = compareString(
      get(v, 'delivery.method'),
      get(selectionData, '[0]delivery.method')
    )
    const sameDNo = compareString(get(v, 'delivery.no'), get(selectionData, '[0]delivery.no'))
    const sameDPackingInst = compareString(
      get(v, 'delivery.packingInst'),
      get(selectionData, '[0]delivery.packingInst')
    )
    const sameDQuantity = compareString(
      get(v, 'delivery.quantity'),
      get(selectionData, '[0]delivery.quantity')
    )
    const sameDTerms = compareString(
      get(v, 'delivery.terms'),
      get(selectionData, '[0]delivery.terms')
    )
    const sameDType = compareString(get(v, 'delivery.type'), get(selectionData, '[0]delivery.type'))

    return (
      sameVendor &&
      sameDAddress &&
      sameDCountry &&
      sameDLocation &&
      sameDMethod &&
      sameDNo &&
      sameDPackingInst &&
      sameDQuantity &&
      sameDTerms &&
      sameDType
    )
  })

  const groupAllowed = selection.every((i) => filteredData.map((j) => j._id).includes(i))

  const [removingBulk, removeFunc] = useSubmit(RequisitionsApi.lines.removeBulk)

  async function removeSelection() {
    console.log({ selection })
    setSelection([])
    setSubmitting(true)
    try {
      await removeFunc({ selection })
      fetch()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <RequisitionsLines
      {...{
        isUpdatable: props.isUpdatable,
        list,
        groupAllowed,
        fetching,
        fetch,
        visible,
        submitting,
        requisition,
        line,
        onShow,
        onCancel,
        checkForm,
        submit,
        removingBulk,
        removing,
        remove,
        update,
        modalType,
        formRef,
        removeSelection,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
        sales,
      }}
    />
  )
}
export default RequisitionsLinesCont
